const _excluded = ["hiddenLink", "children"],
  _excluded2 = ["children"],
  _excluded3 = ["link", "activePage", "dropdownIconSize", "navLink"],
  _excluded4 = ["id", "title", "url", "targetBlank", "slug"],
  _excluded5 = ["id", "title", "url", "targetBlank"],
  _excluded6 = ["id", "title", "url", "targetBlank"],
  _excluded7 = ["component", "hiddenLink", "icon"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React, { useId, useState } from "react";
import styled, { css } from "styled-components";
import { colorBrandBase, colorLightest, colorWhite, colorDarkest, focusOutlineOffset, standardFocusStyleDeclarations, borderRadiusStandard, focusOutlineWidth, focusOutlineStyle, focusOutlineColor, token } from "@nib-components/theme";
import { PhoneSystemIcon, ChevronDownSystemIcon } from "@nib/icons";
import { Inline, Hidden, Container, breakpoint, map, p, px, py, m, mr } from "@nib/layout";
import Link from "@nib-components/link";
export const validVariationValues = ["arhi", "shareholders", "nz", "foundation", "thrive", "providers", "international", "internationalStudents", "internationalWorkers", "gu"];
export const HeaderWrapper = styled.header.attrs({
  "data-mesh-component": "HEADER"
})`
  display: none;
  background-color: var(--smallHeaderColorBg, ${colorWhite});

  ${breakpoint("xl")`
    display: flex;
    flex-direction: column;
  `}
`;
export const HeaderContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  ${py(4)};
`;
export const LogoLink = styled(Link).attrs({
  underline: false,
  "data-testid": "logo-link"
})`
  &&& {
    display: flex;
    align-items: center;
    ${p(4)};

    ${breakpoint("xl", "xxl")`
      ${px(3)};
    `}
  }

  &:focus-visible {
    ${standardFocusStyleDeclarations};
    outline-offset: -${focusOutlineOffset};
  }
`;
LogoLink.displayName = "LogoLink";
export const HeaderContact = styled.div`
  display: flex;
  align-items: center;
`;
export const PhoneNumber = styled.a`
  display: flex;
  align-items: center;
  font-size: 2rem;
  font-weight: bold;
  text-decoration: none;
  color: var(--smallHeaderColorFgIcons, ${colorBrandBase});

  &:focus-visible {
    ${standardFocusStyleDeclarations};
  }
`;
export const PhoneIcon = styled(PhoneSystemIcon)`
  color: var(--smallHeaderColorFgIcons, ${colorBrandBase});
`;
export const HeaderLinks = styled.div`
  display: flex;
  align-items: center;
`; // eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SearchLink = styled(_ref => {
  let {
      hiddenLink,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("a", _extends({}, rest, {
    "aria-label": "Search"
  }), children);
})`
  display: ${_ref2 => {
  let {
    hiddenLink
  } = _ref2;
  return hiddenLink ? `none` : `block`;
}};
  ${mr(2)};
  ${p(3)};
  line-height: 0;
  border: none;
  background: transparent;
  color: var(--smallHeaderColorFgIcons, ${colorBrandBase});

  &:hover {
    cursor: pointer;
  }

  &:focus-visible {
    ${standardFocusStyleDeclarations};
  }
`;
export const HeaderNav = styled.nav`
  color: var(--headerColorFgNav, ${colorDarkest});
  background-color: var(--headerColorBgNav, ${colorLightest});
`;
export const NavMenu = styled.ul`
  display: flex;
  ${m(0)};
  ${px(0)};
  list-style: none;

  ${_ref3 => {
  let {
    navAlignment
  } = _ref3;
  return navAlignment && `justify-content: center`;
}};
`;
export const NavItem = styled.li.attrs({
  "data-testid": "nav-item"
})`
  display: flex;
  position: relative;

  ${_ref4 => {
  let {
    positionRight
  } = _ref4;
  return positionRight && `margin-inline-start: auto`;
}};
`;
NavItem.displayName = "NavItem";
export const baseNavLinkStyles = css`
  /* Button reset styles */
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  margin: 0;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  position: relative;
  ${p(4)};
  font-size: 1rem;
  font-weight: bold;
  text-decoration: none;
  color: ${_ref5 => {
  let {
    color
  } = _ref5;
  return color || "inherit";
}};

  ${NavItem}:focus-visible > &&,
  ${NavItem}:hover > && {
    color: var(--headerColorFgNavHover, ${colorBrandBase});
  }

  ${NavItem}:focus-within > && {
    color: var(--headerColorFgNavHover, ${colorBrandBase});
  }

  &:focus-visible {
    outline: ${focusOutlineWidth} ${focusOutlineStyle} ${token("header.color.border.focus.nav", focusOutlineColor)};
    outline-offset: -${focusOutlineOffset};
    z-index: 1;
  }
`;
export const NavLink = styled(_ref6 => {
  let {
      children
    } = _ref6,
    props = _objectWithoutProperties(_ref6, _excluded2);
  return /*#__PURE__*/React.createElement("a", props, children);
})`
  ${baseNavLinkStyles};
`;
NavLink.displayName = "NavLink";
export const DropdownContainer = styled.ul`
  background-color: var(--themeColorBgSurfaceProminent, ${colorWhite});
  border-radius: ${borderRadiusStandard};

  /* Same as hero panel */
  box-shadow: 0 4px 8px 0 hsl(0deg 0% 0% / 15%);
  ${m(0)};
  ${p(0)};
  ${py(4)};
  list-style: none;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 0;
    border-block-start: 4px solid var(--themeColorBorderSelected, ${colorBrandBase});
    position: absolute;
    inset-block-start: 0;
  }
`;
export const NavDropdown = styled.div`
  position: absolute;
  top: calc(100% - 4px);
  ${_ref7 => {
  let {
    positionRight
  } = _ref7;
  return positionRight ? `right: 0` : `left: 0`;
}};
  inset-inline-start: 0;

  /* default for IE11 */
  width: 17rem;

  @supports (width: max-content) {
    width: max-content;
    max-inline-size: 30rem;
  }
  z-index: 10;
  height: 0;
  overflow: hidden;

  &::before {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    border: 8px solid transparent;
    border-block-end: 8px solid var(--themeColorBorderSelected, ${colorBrandBase});
    inset-block-start: 0;
    transform: translateY(-100%);
    ${_ref8 => {
  let {
    positionRight
  } = _ref8;
  return positionRight ? `right: 2rem` : `left: 2rem`;
}};
    inset-inline-start: 2rem;
  }

  ${NavItem}:focus-visible > &&,
  ${NavItem}:hover > && {
    height: auto;
    overflow: visible;
  }

  ${NavItem}:focus-within > && {
    height: auto;
    overflow: visible;
  }
`;
export const NavDropdownLink = styled(Link).attrs({
  underline: false,
  "data-testid": "nav-dropdown-link"
})`
  &&& {
    display: block;
    ${px(5)};
    ${py(3)};
    color: var(--themeColorFg, inherit);

    ${breakpoint("xl", "xxl")`
      ${px(3)};
    `}
  }

  &:focus-visible,
  &:hover,
  &:active {
    color: var(--themeColorFgBrand, ${colorBrandBase});
    box-shadow: inset 4px 0 var(--themeColorBorderSelected, ${colorBrandBase});
  }

  ${_ref9 => {
  let {
    current
  } = _ref9;
  return current && css`
      color: var(--themeColorFgBrand, ${colorBrandBase});
      box-shadow: inset 4px 0 var(--themeColorBorderSelected, ${colorBrandBase});
    `;
}}

  &:focus-visible {
    ${standardFocusStyleDeclarations};
    outline-offset: -${focusOutlineOffset};
  }
`;
export const NavDropdownSubLink = styled(NavDropdownLink).attrs({
  "data-testid": "nav-dropdown-sub-link"
})`
  padding-left: 2.5rem;
`;
NavDropdownSubLink.displayName = "NavDropdownSubLink";
export const NavDropdownHeading = styled.div`
  font-weight: bold;
  ${px(5)};
  ${py(3)};

  ${breakpoint("xl", "xxl")`
    ${px(3)};
  `}
`;
export const DropdownIcon = styled(ChevronDownSystemIcon)`
  vertical-align: middle;
  ${_ref10 => {
  let {
    breakpoints
  } = _ref10;
  return map(breakpoints, val => css`
          width: ${val}px;
          height: ${val}px;
        `);
}}
  transform: translate(0deg);

  ${NavItem}:focus-visible &&,
  ${NavItem}:hover && {
    transform: rotate(180deg);
  }

  /* FIXME: && here should fix things */
  ${NavItem}:focus-within && {
    transform: rotate(180deg);
  }
`;
const LineHeightOne = styled.span`
  line-height: 1;
`;
const NoWrapInline = styled(Inline)`
  flex-wrap: nowrap;
  line-height: 0;
`;
export const NavLinkItem = props => {
  const [isExpanded, setIsExpanded] = useState(false);
  const {
      link,
      activePage,
      dropdownIconSize = 24,
      navLink
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded3);
  const {
      id,
      title,
      url,
      targetBlank,
      slug
    } = link,
    otherLinkProps = _objectWithoutProperties(link, _excluded4);
  const NavLink = navLink;
  const Icon = link.icon;
  const expanderId = useId();
  return link.children ? /*#__PURE__*/React.createElement(NavItem, {
    positionRight: link.positionRight,
    onMouseEnter: () => setIsExpanded(true),
    onMouseLeave: () => setIsExpanded(false),
    onFocus: () => setIsExpanded(true),
    onBlur: () => setIsExpanded(false)
  }, /*#__PURE__*/React.createElement(NavLink, _extends({
    id: `${id}-desktop`,
    title: title,
    href: url,
    target: targetBlank && "_blank",
    rel: targetBlank && "noopener noreferrer",
    "aria-expanded": isExpanded,
    "aria-controls": expanderId,
    "aria-current": activePage === slug ? "page" : null,
    isActivePage: activePage === slug
  }, otherLinkProps, otherProps), /*#__PURE__*/React.createElement(NoWrapInline, {
    space: 2,
    verticalAlign: "center"
  }, Icon ? /*#__PURE__*/React.createElement(Icon, {
    size: "md"
  }) : "", /*#__PURE__*/React.createElement(LineHeightOne, null, link.title), /*#__PURE__*/React.createElement(DropdownIcon, {
    breakpoints: {
      xl: 16,
      xxl: dropdownIconSize
    }
  }))), /*#__PURE__*/React.createElement(NavDropdown, {
    id: expanderId,
    "aria-label": link.title,
    positionRight: link.positionRight
  }, /*#__PURE__*/React.createElement(DropdownContainer, null, link.children && link.children.map(child => {
    const {
        id,
        title,
        url,
        targetBlank
      } = child,
      otherProps = _objectWithoutProperties(child, _excluded5);
    return /*#__PURE__*/React.createElement("li", {
      key: `${child.id}-desktop`
    }, /*#__PURE__*/React.createElement(NavDropdownLink, _extends({
      id: `${id}-desktop`,
      title: title,
      href: url,
      target: targetBlank && "_blank",
      rel: targetBlank && "noopener noreferrer"
    }, otherProps), title), child.children && /*#__PURE__*/React.createElement(NavMenu, {
      style: {
        flexDirection: "column"
      }
    }, child.children && child.children.map(subChild => {
      const {
          id,
          title,
          url,
          targetBlank
        } = subChild,
        otherProps = _objectWithoutProperties(subChild, _excluded6);
      return /*#__PURE__*/React.createElement("li", {
        key: `${subChild.id}-desktop`
      }, /*#__PURE__*/React.createElement(NavDropdownSubLink, _extends({
        id: `${id}-desktop`,
        title: title,
        href: url,
        target: targetBlank && "_blank",
        rel: targetBlank && "noopener noreferrer"
      }, otherProps), /*#__PURE__*/React.createElement(Inline, {
        verticalAlign: "center",
        space: 2
      }, /*#__PURE__*/React.createElement(Hidden, {
        screenReader: true
      }, /*#__PURE__*/React.createElement("span", null, "\u2014")), /*#__PURE__*/React.createElement("span", null, subChild.title))));
    })));
  })))) : /*#__PURE__*/React.createElement(NavItem, {
    positionRight: link.positionRight
  }, /*#__PURE__*/React.createElement(NavLink, _extends({
    id: `${link.id}-desktop`,
    title: link.title,
    href: link.url,
    target: link.targetBlank && "_blank",
    rel: link.targetBlank && "noopener noreferrer",
    key: `${link.id}-desktop`,
    isActivePage: activePage === link.slug,
    "aria-current": activePage === link.slug ? "page" : null
  }, otherProps), /*#__PURE__*/React.createElement(NoWrapInline, {
    space: 2,
    verticalAlign: "center"
  }, Icon ? /*#__PURE__*/React.createElement(Icon, {
    size: "md"
  }) : "", /*#__PURE__*/React.createElement(LineHeightOne, null, link.title))));
};
NavLinkItem.displayName = "NavLinkItem"; // eslint-disable-next-line @typescript-eslint/no-unused-vars, jsx-a11y/anchor-has-content
export const HeaderLink = styled(_ref11 => {
  let {
      component: Component,
      hiddenLink,
      icon
    } = _ref11,
    rest = _objectWithoutProperties(_ref11, _excluded7);
  return Component ? /*#__PURE__*/React.createElement(Component, _extends({
    "data-testid": "header-link"
  }, rest)) : /*#__PURE__*/React.createElement("a", _extends({
    "data-testid": "header-link"
  }, rest));
})`
  display: ${_ref12 => {
  let {
    hiddenLink
  } = _ref12;
  return hiddenLink ? `none` : `flex`;
}};
  flex-direction: row;
  align-items: center;
  ${p(4)};
  border: none;
  border-left: 1px solid var(--smallHeaderColorBorderDivider, ${colorLightest});
  background: transparent;
  color: var(--themeColorFgBrand, ${colorBrandBase});

  &:hover {
    cursor: pointer;
  }

  &:focus-visible {
    ${standardFocusStyleDeclarations};
    outline-offset: -${focusOutlineOffset};
    z-index: 1;
  }
`;
export const SEARCH_URL = "/search";
HeaderLink.displayName = "HeaderLink";